// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bLA4","right":"styles_right__1qndu"};